export const columnNames = {
  1: 'Betalingsoppfordring',
  2: 'Inkassovarsel',
  '24soId': 'KundeID Husleie.no',
  3: 'Rettslige skritt',
  4: 'Overvåking',
  5: 'Inkasso avsluttet',
  activated: 'Aktivert',
  active: 'Aktivt',
  advance: 'Forskudd',
  amountUncollected: 'Beløp (uoppgjort)',
  annual: 'Ãrlig',
  balance: 'Saldo',
  bankAccountNumber: 'Bankkonto',
  bimonthly: 'Annenhver måned',
  bindingPeriod: 'Bindingstid',
  biquarterly: 'To ganger per kvartal',
  closed: 'Lukket',
  contractEndDate: 'Kontraktslutt',
  contractStartDate: 'Kontraktstart',
  creditNote: 'Kreditnota',
  creditNoted: 'Kreditert',
  current: 'Inneværende',
  customBuildingId: 'Bygg-ID',
  customClientId: 'KundeID',
  debCaseNumber: 'Saksnummer',
  debCaseStatus: 'Inkassostatus',
  deleted: 'Slettet',
  delta30: '1-30',
  delta60: '31-60',
  delta90: '61-90',
  deltaMore: 'Over 90',
  deposit: 'Depositum',
  depositAccountEasyBank: 'Depositumskonto Lea bank',
  depositAccountStatus: 'Status',
  dueDay: 'Forfallsdag',
  dueInterval: 'Fakturafrekvens',
  duePeriod: 'Forfallsperiode',
  duplicate: 'Duplikat',
  empty: '',
  exempt: 'Fritatt',
  exemptDebtCollection: 'Inkassofritak',
  furnished: 'Møblering',
  husleieId: 'HusleieID',
  indexAdjustment: 'Indeksreg.',
  invoiceAmount: 'Fakturabeløp',
  invoiceAmountVat: 'Mvabeløp',
  invoiceDescription: 'Beskrivelse',
  invoiceIssuedDate: 'Ordredato',
  invoiceNumber: 'Fakturanummer',
  invoiceOrderId: 'Ordrenummer',
  invoicePeriod: 'Periode',
  invoiceRowText: 'Fakturalinjetekst',
  invoiceStatus: 'Betalingstatus',
  invoiceType: 'Type',
  invoiceUnpaidAmount: 'Uteståendebeløp',
  landlord: 'Utleier',
  monthly: 'Månedlig',
  nextIndexAdjustmetDate: 'Neste indeksreg.',
  no: 'Nei',
  notActivated: 'Ikke aktivert',
  notExempt: 'Ikke fritatt',
  notStarted: 'Ikke started',
  noticePeriod: 'Oppsigelsetid',
  numberOfDaysToExpiration: 'Dager til utløp',
  numberOfDaysToStart: 'Dager til oppstart',
  open: 'Åpen',
  orderDate: 'Bilagsdato',
  otherInvoice: 'Tilleggsfaktura',
  paidDate: 'Innbetalingsdato',
  paused: 'Pauset',
  paymentDeadline: 'Innbetalingfrist',
  postpay: 'Etterskudd',
  prepaid: 'Forskuddsbetalt',
  quarterly: 'Kvartalsvis',
  rent: 'Husleie',
  rentInvoice: 'Husleie',
  rentalObject: 'Leieobjekt',
  rentalObjectAddress: 'Adresse',
  rentalObjectAddressPostalarea: 'Poststed',
  rentalObjectAddressZipcode: 'Postnummer',
  rentalObjectAlias: 'Leieobjektsalias',
  rentalObjectApartmentNumber: 'Leilighetsnummer',
  rentalObjectOccupied: 'Bebodd',
  rentalObjectRoomNumber: 'Romnummer',
  resigned: 'Avsluttet',
  semiAnnual: 'Halvårlig',
  show: 'Vis',
  status: 'Status',
  suspended: 'Suspandert',
  tenancyStatus: 'Leieforholdstatus',
  tenantAddress: 'Adresse',
  tenantEmail: 'E-post',
  tenantName: 'Leietaker',
  tenantPhone: 'Telefon',
  terminate: 'Avslutt',
  transactionAmount: 'Beløp',
  transactionDate: 'Utbetalingsdato',
  transactionPaymentDate: 'Innbetalingsdato',
  transfered: 'Overført',
  typeOfHousing: 'Boligtype',
  unknown: 'Ukjent',
  vat: 'MVA',
  yes: 'Ja',
};

export const columnValues = {
  tenancyStatus: {
    active: 'Aktiv',
    resigned: 'Avsluttet',
  },
  invoiceType: {
    rentInvoice: 'Husleie',
    otherInvoice: 'Tilleggsfaktura',
    creditNote: 'Kreditnota',
  },
  invoiceStatus: {
    open: 'Åpen',
    creditNoted: 'Kreditert',
    creditNote: 'Kreditnota',
    closed: 'Lukket',
  },
  duePeriod: {
    postpay: 'Etterskudd',
    current: 'Inneværende',
    advance: 'Forskudd',
  },
  dueInterval: {
    monthly: 'Månedlig',
    quarterly: 'Kvartalsvis',
  },
  exemptDebtCollection: {
    noexempt: 'Ikke fritatt',
    exempt: 'Fritatt',
  },
  indexAdjustment: {
    activated: 'Aktivert',
    notActivated: 'Ikke aktivert',
  },
};
